import { Box } from "@mui/material";
import { useEffect } from "react";
import { WrapperLoading } from "@src/shared/components";
import { ChangePassword } from "@src/features/сhangePassword";
import { useGetUserInfoMe } from "@src/entities/user";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";

import styles from "./ChangePasswordPage.module.scss";

export const ChangePasswordPage = () => {
  const { isPending: isGetUserInfoMeLoading, isError: isGetUserInfoMeError } =
    useGetUserInfoMe();
  const clearInfo = userАccountСhangesStore((state) => state.clearInfo);

  useEffect(() => {
    return () => {
      clearInfo();
    };
  }, []);

  const isLoading = isGetUserInfoMeLoading;
  const isError = isGetUserInfoMeError;

  return (
    <WrapperLoading isLoading={isLoading} isError={isError}>
      <Box className={`${styles.root} montserrat-font`}>
        <h1 className={styles.title}>Сменить пароль</h1>
        <ChangePassword />
      </Box>
    </WrapperLoading>
  );
};
